import React from "react";
import { Button, Col, Container, Row, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import api from "../../../services/httpClient";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../assets/styles/layers.scss";

const CreateLayerForms = ({ area, selectedColor = "#000000", onColorChange }) => {
  const navigate = useNavigate();
  const [layerName, setLayerName] = React.useState("");
  const [saving, setSaving] = React.useState(false);
  const [layerNameError, setLayerNameError] = React.useState("");

  const layerNameRegex = /^[\p{L}0-9\s\-%]*$/u;
  const layerNameCharRegex = /^[\p{L}0-9\s\-%]$/u;

  const validateLayerName = React.useCallback((value) => {
    if (layerNameRegex.test(value)) {
      return "";
    }

    const invalidChar = [...String(value)].find((char) => !layerNameCharRegex.test(char));
    const invalidCharLabel = invalidChar ?? "?";
    return `Nazwa niepoprawna. Znak ${invalidCharLabel} niedozwolony`;
  }, [layerNameRegex, layerNameCharRegex]);

  const handleSave = async () => {
    const validationError = validateLayerName(layerName);
    setLayerNameError(validationError);
    if (validationError) {
      return;
    }

    try {
      setSaving(true);

      const payload = {
        name: layerName,
        area: area || "",
        color: selectedColor,
      };

      const response = await api.post("/Layer", payload);

      if (response.status === 201) {
        const newLayerId = response.data;
        alert(`Warstwa została utworzona pomyślnie! ID: ${newLayerId}`);
        navigate("/layers");
      }
    } catch (error) {
      if (error.response?.status === 400) {
        alert("Błąd walidacji: Sprawdź poprawność danych.");
      } else if (error.response?.status === 423) {
        alert("Baza danych jest obecnie zablokowana. Zmiana nie może zostać wykonana");
      } else if (error.response?.status === 500) {
        alert("Błąd serwera: Spróbuj ponownie później.");
      } else {
        alert("Wystąpił błąd podczas tworzenia warstwy.");
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <Container fluid>
      <Row className="mb-3">
        <Col>
          <Form.Label style={{ fontWeight: "bold" }}>Nazwa warstwy</Form.Label>
          <Form.Control
            type="text"
            placeholder="Wprowadź wartość"
            value={layerName}
            isInvalid={Boolean(layerNameError)}
            onChange={(e) => {
              const nextValue = e.target.value;
              setLayerName(nextValue);
              setLayerNameError(validateLayerName(nextValue));
            }}
          />
          <Form.Control.Feedback type="invalid">{layerNameError}</Form.Control.Feedback>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col>
          <Form.Label style={{ fontWeight: "bold" }}>Kolor warstwy</Form.Label>
          <div className="d-flex gap-2">
            <Form.Control
              type="color"
              value={selectedColor}
              onChange={(e) => onColorChange?.(e.target.value)}
              style={{ width: "60px" }}
            />
            <Form.Control
              type="text"
              value={selectedColor}
              onChange={(e) => onColorChange?.(e.target.value)}
              placeholder="#000000"
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <Button
            variant="primary"
            size="sm"
            className="layers-button-letters"
            onClick={handleSave}
            disabled={saving || Boolean(layerNameError)}
          >
            {saving ? "Zapisywanie..." : "Zapisz"}
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default CreateLayerForms;
